import React from 'react';
import { Icons } from '../Icons/Icons';

export interface Arrow {

}

export const Arrow = () => {
    return (
            <div className={'expandable-item__arrow'}>
                <Icons />
                <svg viewBox="0 0 12 7" className="icon icon--dataset-arrow">
                    <use xlinkHref={'#dataset-arrow'} />
                </svg>
            </div>
    )
}
